export interface FieldSortCriterionValue {
  fieldName: string;
  isAscending: boolean;
}

export type FieldSortCriterion = FieldSortCriterionValue | null;

export function getNextSortCriterion(
  currentSort: FieldSortCriterion,
  fieldName: string,
  descendingFirstFields: ReadonlySet<string> = new Set(),
): FieldSortCriterionValue {
  return {
    fieldName,
    isAscending: currentSort?.fieldName === fieldName
      ? !currentSort.isAscending
      : !descendingFirstFields.has(fieldName),
  };
}
